import apiClient from "./config";
import { CRM_ENDPOINTS } from "./endpoints";

// Contacts
export const getContacts = () => apiClient.get(CRM_ENDPOINTS.GET_CONTACTS);
export const addNewContact = (contact) => apiClient.create(CRM_ENDPOINTS.ADD_NEW_CONTACT, contact);
export const updateContact = (contact) => apiClient.update(CRM_ENDPOINTS.UPDATE_CONTACT + '/' + contact._id, contact);
export const deleteContact = (contact) => apiClient.delete(CRM_ENDPOINTS.DELETE_CONTACT + '/' + contact);

// Companies
export const getCompanies = () => apiClient.get(CRM_ENDPOINTS.GET_COMPANIES);
export const addNewCompanies = (company) => apiClient.create(CRM_ENDPOINTS.ADD_NEW_COMPANIES, company);
export const updateCompanies = (company) => apiClient.update(CRM_ENDPOINTS.UPDATE_COMPANIES + '/' + company._id, company);
export const deleteCompanies = (company) => apiClient.delete(CRM_ENDPOINTS.DELETE_COMPANIES + '/' + company);

// Leads
export const getLeads = () => apiClient.get(CRM_ENDPOINTS.GET_LEADS);
export const addNewLead = (lead) => apiClient.create(CRM_ENDPOINTS.ADD_NEW_LEAD, lead);
export const updateLead = (lead) => apiClient.update(CRM_ENDPOINTS.UPDATE_LEAD + '/' + lead._id, lead);
export const deleteLead = (lead) => apiClient.delete(CRM_ENDPOINTS.DELETE_LEAD + '/' + lead);

// Deals
export const getDeals = () => apiClient.get(CRM_ENDPOINTS.GET_DEALS);

